import React, { useState, useEffect } from 'react';
import api from '../../utils/api';
import '../PageStyles.css';

const ClientsServices = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await api.get('/clients-services');
        setItems(response.data);
      } catch (error) {
        console.error('Failed to fetch clients/services:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  if (loading) return <div className="loading">Loading...</div>;

  const clients = items.filter((item) => item.type === 'client');
  const services = items.filter((item) => item.type === 'service');

  return (
    <div className="page-container">
      <div className="container">
        <h1>Clients & Services</h1>

        {services.length > 0 && (
          <section>
            <h2>Our Services</h2>
            <div className="grid">
              {services.map((service) => (
                <div key={service.id} className="card">
                  {service.logo_url && <img src={service.logo_url} alt={service.name} />}
                  <h3>{service.name}</h3>
                  {service.description && <p>{service.description}</p>}
                </div>
              ))}
            </div>
          </section>
        )}

        {clients.length > 0 && (
          <section style={{ marginTop: '40px' }}>
            <h2>Our Clients</h2>
            <div className="grid">
              {clients.map((client) => (
                <div key={client.id} className="card">
                  {client.logo_url && <img src={client.logo_url} alt={client.name} />}
                  <h3>{client.name}</h3>
                  {client.description && <p>{client.description}</p>}
                  {client.website_url && (
                    <a href={client.website_url} target="_blank" rel="noopener noreferrer">
                      Visit Website
                    </a>
                  )}
                </div>
              ))}
            </div>
          </section>
        )}
      </div>
    </div>
  );
};

export default ClientsServices;
